import {UrlSecurite} from './UrlSecurite';
import {DocSecurite} from './DocSecurite';
export class CommunicationFNSSimple {

	public telContact: string;

	public urlDocConsul: string;

	public identifiantInterne: string;

	public adresseMailContact: string;

	public urlProfilAch: string;

	public docSecurite: DocSecurite;

	public nomContact: string;

	public urlSecurite: UrlSecurite;

	public autre: string;

	constructor() { 
		 		this.telContact = '';
		this.urlDocConsul = '';
		this.identifiantInterne = '';
		this.adresseMailContact = '';
		this.urlProfilAch = '';
		this.docSecurite = new DocSecurite();
		this.nomContact = '';
		this.urlSecurite = new UrlSecurite();
		this.autre = '';
 
	}
}
